import { runpod_permission } from "./runpod.permission";

export const idp_permission= {
    required_permission:['view_idp','add_idp','change_idp','delete_idp','view_skill','add_skill','change_skill','delete_skill','view_competency','add_competency','view_competencycategory','add_competencycategory' ],
    runpod_permission:runpod_permission?.required_permission
}